import type { FC } from 'react';
import { Button, Modal } from 'react-bootstrap';

type SaveAndProceedModalProps = {
  onCancel: () => void;
  onSaveAndProceed: () => void;
};

export const SaveAndProceedModal: FC<SaveAndProceedModalProps> = ({ onCancel, onSaveAndProceed }) => (
  <Modal centered onHide={onCancel} scrollable show>
    <Modal.Header closeButton>
      <Modal.Title>Save changes before proceeding?</Modal.Title>
    </Modal.Header>
    <Modal.Body>You have unsaved changes. Before proceeding, these changes must be saved. Is that okay?</Modal.Body>
    <Modal.Footer>
      <Button onClick={onCancel} variant="link">
        Cancel
      </Button>
      <Button onClick={onSaveAndProceed} variant="primary">
        Save and proceed
      </Button>
    </Modal.Footer>
  </Modal>
);
